import { useMutation } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { apiHeaders } from 'utils/api-headers'
import { useSelector } from 'react-redux'
import { RootState } from 'index'

interface SubscriptionPreviewItem {
  price: string
  quantity: number
}

interface ProrationSettings {
  enabled: boolean
  behavior: 'next_invoice' | 'immediately' | 'none'
}

interface SubscriptionPreviewParams {
  organizationId: number
  subscription: {
    items: SubscriptionPreviewItem[]
    discounts?: Array<{ coupon: string }>
  }
  resetBillingInterval?: boolean
  prorationSettings?: ProrationSettings
  trialDays?: number
}

const useSubscriptionPreview = () => {
  const state = useSelector((state: RootState) => state)

  const previewSubscription = async (params: SubscriptionPreviewParams) => {
    const response = await fetch(
      `${BASE_API_URL}/admin/api/v2/stripe/subscriptions/preview`,
      {
        method: 'POST',
        headers: {
          ...apiHeaders(state),
        },
        body: JSON.stringify(params),
      }
    )

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}))
      // Extract the actual Stripe error message from the nested structure
      const errorMessage =
        errorData.error?.message ||
        errorData.message ||
        'Failed to preview subscription'
      throw new Error(errorMessage)
    }

    return response.json()
  }

  return useMutation(previewSubscription)
}

export default useSubscriptionPreview
